import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Logo from "../../assets/images/ACG.png";
import { useSelector } from "react-redux";

const ErrorFallback = ({
  // error,
  resetErrorBoundary,
}) => {
  const user = useSelector((state) => state.authSlice);
  // console.log("🚀 ~ user:", user);
  const history = useNavigate();
  useEffect(() => {
    if (!user.isLoggedin) {
      history("/login");
    }
  }, []);

  return (
    <div
      role="alert"
      style={{
        fontFamily: "Montserrat, Helvetica, sans-serif",
        display: "flex",
        height: "100vh",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={Logo} width={300} alt="Error" />
      <p style={{ fontSize: "16px", marginTop: 50, marginBottom: 20 }}>
        Oops! Something went wrong.
      </p>
      <div style={{ fontSize: "14px" }}>
        <button
          className="btn btn-primary"
          onClick={() => {
            resetErrorBoundary?.();
            history("/");
          }}
          style={{ marginRight: "10px" }}
        >
          <Link style={{ color: "#fff", textDecoration: "none" }} to="/">
            Home
          </Link>
        </button>
        {/* <button className="btn btn-primary" onClick={resetErrorBoundary} >
					Reload
				</button> */}
      </div>
    </div>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.object,
  resetErrorBoundary: PropTypes.func,
};

export default ErrorFallback;
